module.exports = __webpack_public_path__ + "img/amazon.34c54081.webp";